//import './App.css';
import {useLayoutEffect, useRef, useState}from "react";
import {BrowserRouter as Router, Routes, Route, useLinkClickHandler} from 'react-router-dom'
import { useNavigate } from "react-router";
import Navbar from './components/NavBar';

//pages
import Home from './components/Home'
import IPCar from './components/projects/Ipcar';
import Raum from './components/projects/Raum';
import Nporadio5 from './components/projects/Nporadio5';
import Zitting from './components/Zitting';
import NotFound from './components/Notfound';

//imges
import imglinkedin from './components/img/linkedin.svg';
import imgInstagram from './components/img/instagram.svg';
import imgYoutube from './components/img/youtube.svg';
import imgWhatsapp from './components/img/whatsapp.svg';

//scroll behavior
import ScrollToTop from "./components/ScrollToTop";
import styled  from "styled-components";

import useMouse from "@react-hook/mouse-position";
import { motion, } from "framer-motion"


let mouseXPosition = 0;
let mouseYPosition = 0;
let viewPortHeight = null;
let cursorOpacity= 1;
let mouseClick = false 

const AppContainer = styled.div.attrs(props => ({ style:{ backgroundColor: 'rgb('+props.redColor+', '+props.greenColor+','+props.blueColor+')', }}))`// 26,82,99 default color top: ;

@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,300;0,400;0,700;0,900;1,600&family=Rajdhani:wght@300&display=swap');
 text-align: center;
 cursor: none;
 #root{
    padding: 0;
    margin: 0;
 }


.circle {
  position: fixed;
  z-index: 100;
  display: flex;
  flex-flow: row;
  align-content: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 10px;
  width: 10px;
  background-color: #1e91d6;
  border-radius: 200px;
  pointer-events: none;
  color: #fff;
  text-align: center;
  font-size: 16px;
}
.content{

}

.footer{
  z-index: 5;
  color: white;
  height: 100%;
  ul{
    top: 20%;
    margin:0;
    padding:0;
    opacity: 1;

    img{
      padding-left:10px ;
      padding-right:10px ;
      padding-bottom:9px ;
      margin-bottom: 20px;
    }
  }

  li{
    text-align: center;
    padding-left: 2%;
    padding-right: 2%;
    list-style-type: none;
    display: inline-block;
  }
  @media only screen and (max-width: 500px) {


    margin-top: 20vh;
  }
}

`;

function App() {

  const ref = useRef(null);

  const mouse = useMouse(ref, {
    enterDelay: 100,
    leaveDelay: 100
  });

  const [cursorVariant, setCursorVariant] = useState("default");
  let [device, setDevice] = useState(true) // default laptop 

  let [redScroll, setRedScroll] = useState(7);
  let [greenScroll, setGreenScroll] = useState(10);
  let [blueScroll, setBlueScroll] = useState(5);

  let navigate = useNavigate(); // navigate react function

  let [elementEnter, setElementEnter] = useState(0);
  let [scrollPercentage, setscrollPercentage] = useState(0);


  if (mouse.x !== null) {
    mouseXPosition = mouse.clientX;
  }

  if (mouse.y !== null) {
    mouseYPosition = mouse.clientY;
  }

  const variants = { // cursor settings
    default: {
      opacity: cursorOpacity,
      height: 10,
      width: 10,
      fontSize: "16px",
      backgroundColor: "#fff",
      x: mouseXPosition,
      y: mouseYPosition,
      transition: {
        type: "spring",
        mass: 0.3
      }
    },
    project: {
      opacity: 0.8,
      // backgroundColor: "rgba(255, 255, 255, 0.6)",
      backgroundColor: "#ff770f",
      color: "#000",
      height: 50,
      width: 50,
      fontSize: "18px",
      x: mouseXPosition - 32,
      y: mouseYPosition - 32
    },
  }


  const spring = {
    type: "spring",
    stiffness: 500,
    damping: 28
  };

  function projectEnter(event) {
    setCursorVariant("project");
  }

  function projectLeave(event) {

    setCursorVariant("default");
  }



  function map( x,  in_min,  in_max,  out_min,  out_max){ // maps de waardes van de controller zodat de de ESC ze begrijpt
    return Math.round((x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min)
  }

  function getScrollPercent(){
    var h = document.documentElement,
    b = document.body,
    st = "scrollTop",
    sh = "scrollHeight";

    scrollPercentage= Math.round( // change  scroll to value between 0 and 100
      ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
    );
    setscrollPercentage(window.scrollY)
    //console.log(scrollPercentage)
    redScroll = map(scrollPercentage,0,100,7,26)
    greenScroll = map(scrollPercentage,0,100,10,82)
    blueScroll = map(scrollPercentage,0,100,5,99)
    

    setRedScroll(isNaN( redScroll ) ? "" :  redScroll );
    setGreenScroll(isNaN( greenScroll ) ? "" :  greenScroll );
    setBlueScroll(isNaN( blueScroll ) ? "" :  blueScroll );
      //colorOneChange = map(window.scrollY, 0,450, 26,50)
   

     
  }

  useLayoutEffect(()=>{

 

    viewPortHeight = window.innerHeight;
    if (window.innerWidth >1000){ // switch between mobile and desktop mode
      cursorOpacity = 1 ;
      //console.log("desktop")
    }else{
      cursorOpacity = 0
      //console.log("mobile")
    }
    window.addEventListener("scroll", getScrollPercent);
    //console.log(mouseClick)
    if( elementEnter === 0){  // value on which the cursor will change from small to big
      projectLeave();
      mouseClick = false;
    } else if ( elementEnter == 1 ){
      //console.log("probleem")
     if (mouseClick == true){ // reset of cursor when clicked
   
        elementEnter = 0;
        projectLeave();
      }else{
        console.log("clicked reset")
       projectEnter();
       mouseClick = false;
      }
    }
 
    return () => {
      window.removeEventListener("scroll", getScrollPercent);
    };
  });
 


  //function map( x,  in_min,  in_max,  out_min,  out_max){ // maps de waardes van de controller zodat de de ESC ze begrijpt
   // return ((x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min).toFixed(0) onClick={()=>{mouseClick = true}}
  //}
  return (
   
       
      <AppContainer redColor={redScroll} greenColor={greenScroll} blueColor={blueScroll}   ref={ref} onClick={()=>{mouseClick = true}}>
       
         <motion.div
            variants={variants}
            className="circle"
            animate={cursorVariant}
            transition={spring}>
          </motion.div>
          <Navbar/>
          <ScrollToTop>
            <Routes>
              <Route path="/" exact element={<Home scrollPercentage={scrollPercentage} elementEnter={elementEnter=>setElementEnter(elementEnter)}/>}/>
              <Route path="/ip-car" element={<IPCar elementEnter={elementEnter=>setElementEnter(elementEnter)}/>}/>
              <Route path="/raum" element={<Raum/>}/>
              <Route path="/arbeidsvitamine"  element={<Nporadio5/>}/>
              <Route path="/zitting"  element={<Zitting/>}/>
              <Route path="*" element={<Home scrollPercentage={scrollPercentage} elementEnter={elementEnter=>setElementEnter(elementEnter)}/>} />
            </Routes>
          </ScrollToTop>
        <div className="footer">
         <ul>
            <img onClick={(e) => {window.location.href = "https://www.linkedin.com/in/dominique-de-vos-70a18777/"; e.preventDefault(); }} src={imglinkedin} alt="Linkedin Logo"/>
            <img onClick={(e) => {window.location.href = "https://www.instagram.com/dominiquedevos94/"; e.preventDefault(); }} src={imgInstagram} alt="Linkedin Logo"/>
            <img onClick={(e) => {window.location.href = "https://www.youtube.com/channel/UCEv8A-adAQDA0OKMDJC6kOQ"; e.preventDefault(); }}src={imgYoutube} alt="Youtube Logo"/> 
            <img onClick={(e) => {window.location.href = "https://wa.me/+31613502611"; e.preventDefault(); }}src={imgWhatsapp} alt="Whatsapp Logo"/> 
          </ul>
        </div>
      </AppContainer>

  );
}

export default App;


// const AppContainer = styled.div`

// @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,300;0,400;0,700;0,900;1,600&family=Rajdhani:wght@300&display=swap');
//  text-align: center;
//  background-color: rgb(${props => props.redColor}, ${props => props.greenColor}, ${props => props.blueColor}); // 26,82,99 default color top: ;
//  cursor: none;
//  #root{
//     padding: 0;
//     margin: 0;
//  }